/** Имя UXFB-события захода в каталог застройщиков. Должно побайтово совпадать с кампаниями в админке UXFB. */
export const UXFB_EVENT_OPEN_DEVELOPER_CATALOG = 'open_developer_catalog';

/** Имя UXFB-события скролла каталога застройщиков (просмотрено ≥ 10 застройщиков). */
export const UXFB_EVENT_SCROLL_DEVELOPER_CATALOG = 'scroll_developer_catalog';

/** Количество застройщиков, после скролла которых уходит `scroll_developer_catalog` (в атрибуте `count` — строкой). */
export const UXFB_SCROLL_DEVELOPER_CATALOG_COUNT = 10;

/** По сценарию события каталога застройщиков отправляются только на десктопе. */
export const UXFB_PLATFORM = 'desktop';

/**
 * Kill-switch клиентских UXFB-событий. По умолчанию события включены; выключаются значением `false`
 * в конфиге (`uxfeedback.clientEvents.enabled`).
 */
export const UXFB_CLIENT_EVENTS_CONFIG_KEY = 'uxfeedback.clientEvents.enabled';
